const Projects = ({ title, description, url, urlRepo, img }) => {
    return (
        <>
            <a className="project-card" target="_blank" rel="noreferrer" href={url} >
                <div className="d-flex flex-column align-items-center justify-content-center h-100">
                    <img src={img} className="img-fluid img-project rounded mb-3 text-center" alt="img-project" />
                    <div className="d-flex flex-column align-items-center text-center w-100">
                        <h3 className="text-uppercase title fs-4 text-center">{title}</h3>
                        <p className="projects-text text-center" style={{ whiteSpace: 'pre-line' }}>{description}</p>
                        <p className="link-projects fw-bold text-center p-1 w-50 mx-auto rounded" style={{ backgroundColor: "#0c64bc", color: 'white' }}>Ver sitio web</p>
                    </div>
                </div>
            </a>
        </>
    )
}

export default Projects;